import React from 'react';
import { VariantType, useVariant } from './VariantProvider';
import { BaseFormControl } from './BaseFormControl';

export type TextFieldProps = {
  /** Tekst eller ikon som kommer før inputfeltet */
  prepend?: React.ReactNode;
  /** Tekst eller ikon som kommer etter inputfeltet */
  append?: React.ReactNode;
  /** Ekstra klassenavn */
  className?: string;
  /** Hvilken valideringsfarge som vises */
  variant?: VariantType;
  /** Deaktiver inputfeltet */
  disabled?: boolean;
  /** Setter inputfeltet i read-only modus */
  readOnly?: boolean;
  /** Størrelsen på TextField
   * @default "medium"
   */
  size?: 'medium' | 'large';
  [key: string]: any;
};

export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      prepend,
      append,
      variant,
      disabled = false,
      readOnly = false,
      className,
      style,
      size = 'medium',
      ...rest
    },
    ref: React.Ref<HTMLInputElement>,
  ) => {
    const contextVariant = useVariant();
    const currentVariant = variant || contextVariant;

    return (
      <BaseFormControl
        disabled={disabled}
        readOnly={readOnly}
        variant={variant}
        prepend={prepend}
        append={append}
        className={className}
        style={style}
        size={size}
      >
        <input
          aria-invalid={currentVariant === 'error'}
          className="eds-form-control"
          disabled={disabled}
          readOnly={readOnly}
          ref={ref}
          {...rest}
        />
      </BaseFormControl>
    );
  },
);
